import { Box } from '@mui/system';
import logo2 from 'assets/images/logo2.png';
import Mint from './mint';
import Traverse from './traverse';

const PlayGame = () => {
  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" padding="20px">
      <img src={logo2} alt="logo" width="300px" />
      <Mint />
      <Traverse />
    </Box>
  );
};

export default PlayGame;
